var installedModules = {};
var moduleToHandlerMapping = {
	99794: {
		getter: function() { return Promise.all([__webpack_require__.e(57338), __webpack_require__.e(60233)]).then(function() { return function() { return __webpack_require__(57338); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	69538: {
		getter: function() { return Promise.all([__webpack_require__.e(22116), __webpack_require__.e(71126), __webpack_require__.e(31242), __webpack_require__.e(60233), __webpack_require__.e(60055)]).then(function() { return function() { return __webpack_require__(31242); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	63764: {
		getter: function() { return __webpack_require__.e(2657).then(function() { return function() { return __webpack_require__(2657); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	29156: {
		getter: function() { return Promise.all([__webpack_require__.e(22116), __webpack_require__.e(34747)]).then(function() { return function() { return __webpack_require__(34747); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	5825: {
		getter: function() { return Promise.all([__webpack_require__.e(71126), __webpack_require__.e(60233), __webpack_require__.e(30130)]).then(function() { return function() { return __webpack_require__(66996); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	66939: {
		getter: function() { return __webpack_require__.e(83894).then(function() { return function() { return __webpack_require__(83894); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	86568: {
		getter: function() { return __webpack_require__.e(46593).then(function() { return function() { return __webpack_require__(31085); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	72911: {
		getter: function() { return __webpack_require__.e(46593).then(function() { return function() { return __webpack_require__(14041); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	98628: {
		getter: function() { return __webpack_require__.e(50527).then(function() { return function() { return __webpack_require__(50527); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	97669: {
		getter: function() { return __webpack_require__.e(68546).then(function() { return function() { return __webpack_require__(68546); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	11201: {
		getter: function() { return __webpack_require__.e(46593).then(function() { return function() { return __webpack_require__(25873); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false,
			  "layer": null
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	60233: {
		getter: function() { return __webpack_require__.e(46593).then(function() { return function() { return __webpack_require__(43144); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	13324: {
		getter: function() { return Promise.all([__webpack_require__.e(30005), __webpack_require__.e(69941), __webpack_require__.e(57077)]).then(function() { return function() { return __webpack_require__(30005); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false,
			  "layer": null
			},
			scope: ["default"],
		},
		shareKey: "@sentry/nextjs",
	},
	10893: {
		getter: function() { return __webpack_require__.e(69387).then(function() { return function() { return __webpack_require__(91768); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@croquiscom-pvt/zds-themes",
	},
	57077: {
		getter: function() { return __webpack_require__.e(60805).then(function() { return function() { return __webpack_require__(60805); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false,
			  "layer": null
			},
			scope: ["default"],
		},
		shareKey: "@sentry/core",
	},
	69941: {
		getter: function() { return Promise.all([__webpack_require__.e(30041), __webpack_require__.e(57077), __webpack_require__.e(65689)]).then(function() { return function() { return __webpack_require__(30041); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false,
			  "layer": null
			},
			scope: ["default"],
		},
		shareKey: "@sentry/react",
	},
	65689: {
		getter: function() { return Promise.all([__webpack_require__.e(47173), __webpack_require__.e(18102)]).then(function() { return function() { return __webpack_require__(18102); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false,
			  "layer": null
			},
			scope: ["default"],
		},
		shareKey: "@sentry/browser",
	},
	77821: {
		getter: function() { return Promise.all([__webpack_require__.e(10590), __webpack_require__.e(27565), __webpack_require__.e(5412), __webpack_require__.e(22146), __webpack_require__.e(16518), __webpack_require__.e(58897), __webpack_require__.e(42102), __webpack_require__.e(26584), __webpack_require__.e(41993), __webpack_require__.e(28027), __webpack_require__.e(55655)]).then(function() { return function() { return __webpack_require__(43659); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@croquiscom-pvt/zds",
	},
	82604: {
		getter: function() { return __webpack_require__.e(1634).then(function() { return function() { return __webpack_require__(79253); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/config",
	},
	42203: {
		getter: function() { return __webpack_require__.e(61513).then(function() { return function() { return __webpack_require__(83894); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "14.2.35",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	}
};
var initialConsumes = [99794,69538,63764,29156,5825,66939,86568,72911,98628,97669,86568,72911,11201,60233,13324,69538,77821,82604,29156,63764,42203,69941];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"2905": [
		11201
	],
	"38792": [
		86568,
		72911,
		11201,
		60233
	],
	"42203": [
		42203
	],
	"52979": [
		13324
	],
	"55527": [
		63764,
		29156,
		5825,
		66939,
		86568,
		72911,
		98628,
		97669
	],
	"55655": [
		10893
	],
	"57077": [
		57077
	],
	"60233": [
		60233
	],
	"65689": [
		65689
	],
	"69538": [
		69538
	],
	"69941": [
		69941
	],
	"90636": [
		13324,
		69538,
		77821,
		82604,
		29156,
		63764
	],
	"99794": [
		99794
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}